import {
  SIGNIN_REQUEST,
  SIGNIN_SUCCESS,
  SIGNIN_FAILURE,
  REFRESH_SUCCESS,
  LOGOUT,
} from "./actions.types";

export const signinRequest = (payload: {
  email: string;
  password: string;
}) => ({
  type: SIGNIN_REQUEST,
  payload,
});

export const signInSuccess = (payload: {
  user: any;
  accessToken: string;
  refreshToken: string;
  expireIn: string;
}) => ({
  type: SIGNIN_SUCCESS,
  payload,
});

export const signinFailure = (error: string) => ({
  type: SIGNIN_FAILURE,
  payload: error,
});

export const refreshSuccess = (payload: {
  accessToken: string;
  refreshToken: string;
  expireIn: string;
}) => ({
  type: REFRESH_SUCCESS,
  payload,
});

export const logout = () => ({ type: LOGOUT });
